import _slicedToArray from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import React, { useState } from "react";
import { string } from "prop-types";
import Styled from "styled-components"; // Colors

import { primary, backgrounds } from "@uprise/colors";
var SwitchStyle = Styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      display: flex;\n      flexDirection: row;\n\tpadding: 0;\n      width: auto;\n      height: 30px;\n      color: ", ";\n      font-size: 12px;\n"])), backgrounds.white);
var ToggleLeftStyle = Styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      color: ", "};\n      background-color: ", "};\n      cursor: ", ";\n      border-radius: 0;\n      border-top-left-radius: 10px;\n      border-bottom-left-radius: 10px;\n      border: 1px solid ", ";\n      width: auto;\n      height: 30px;\n      padding: 11px 16px;\n"])), function (props) {
  return props.active ? backgrounds.white : primary.purple;
}, function (props) {
  return props.active ? primary.purple : backgrounds.white;
}, function (props) {
  return props.active ? "arrow" : "pointer";
}, primary.purple);
var ToggleRightStyle = Styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      cursor: ", ";\n      color: ", "};\n      background-color: ", "};\n      border-radius: 0;\n      border-top-right-radius: 10px;\n      border-bottom-right-radius: 10px;\n      border: 1px solid ", ";\n      width: auto;\n      height: 30px;\n      padding: 11px 16px;\n"])), function (props) {
  return props.active ? "arrow" : "pointer";
}, function (props) {
  return props.active ? backgrounds.white : primary.purple;
}, function (props) {
  return props.active ? primary.purple : backgrounds.white;
}, primary.purple);
export var Switch = function Switch(_ref) {
  var defaultActive = _ref.defaultActive,
      leftLabel = _ref.leftLabel,
      leftAction = _ref.leftAction,
      rightLabel = _ref.rightLabel,
      rightAction = _ref.rightAction;

  var _useState = useState(defaultActive === "left" ? true : false),
      _useState2 = _slicedToArray(_useState, 2),
      leftActive = _useState2[0],
      setLeftActive = _useState2[1];

  var handleClick = function handleClick() {
    if (leftActive) {
      setLeftActive(false);
      rightAction();
    } else {
      setLeftActive(true);
      leftAction();
    }
  };

  return /*#__PURE__*/React.createElement(SwitchStyle, null, /*#__PURE__*/React.createElement(ToggleLeftStyle, {
    active: leftActive,
    onClick: !leftActive ? function () {
      return handleClick();
    } : null
  }, leftLabel), /*#__PURE__*/React.createElement(ToggleRightStyle, {
    active: !leftActive,
    onClick: leftActive ? function () {
      return handleClick();
    } : null
  }, rightLabel));
};
Switch.propTypes = {
  defaultActive: string
};
Switch.defaultProps = {
  defaultActive: "right"
};